import React from 'react'
import './footer.css'
import {BiLogoFacebook} from 'react-icons/bi'
import {FiInstagram} from 'react-icons/fi'
// import {FiTwitter} from 'react-icons/fi'
import { BsLinkedin } from 'react-icons/bs'
import { FaGithub } from 'react-icons/fa'


const Footer = () => {
  return (
    <footer>
      <a href="#home" className="footer__logo">Partham Kumar</a>
      <ul className="permalinks">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        {/* <li><a href="#testimonials">Testimonials</a></li> */}
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/partham.chawla.313/"><BiLogoFacebook /></a>
        <a href="https://www.instagram.com/parthamchawla1/"><FiInstagram /></a>
        <a href="https://www.linkedin.com/in/partham-chawla-a8494021a/" target='_blank' rel="noreferrer"><BsLinkedin/></a>
        <a href="https://github.com/ParthamKumar" target='_blank' rel="noreferrer"><FaGithub /></a>
        {/* <a href="https://twitter.com"><FiTwitter /></a> */}
      </div>

      <div className="footer__copyright">
        <small>&copy; All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
